import React from "react";
import { Link } from "react-router-dom";

export default function BlogCard({
  href = "#",
  title,
  content,
  imageSrc,
  className = "",
  isFrequentQuestion = false
}) {
  return (
    <Link
      to={isFrequentQuestion ? "#" : href}
      className={[
        "flex h-full flex-col overflow-hidden rounded-[5px] border border-[#E5E5E5] bg-white transition hover:border-[#CFCFCF]",
        className,
      ].join(" ")}
    >
      {/* Image */}
      <div className="h-[260px] w-full overflow-hidden bg-[#F5F5F5]">
        {imageSrc ? (
          <img
            src={imageSrc}
            alt={title}
            loading="lazy"
            className="h-full w-full object-cover"
          />
        ) : (
          <div className="h-full w-full bg-[#F1F1F1]" />
        )}
      </div>

      {/* Body */}
      <div className="flex flex-1 flex-col p-[20px]">
        <h3 className="font-inter text-[14px] md:text-[18px] font-medium leading-[28px] tracking-[-0.45px] text-black line-clamp-2">
          {title}
        </h3>

        <p className="mt-4 font-inter text-[12px] md:text-[14px] leading-[1.7] text-[#52525C] line-clamp-4">
          {content}
        </p>

      </div>
    </Link>
  );
}
